import { useEffect, useState } from "react"


const useTool = () => {
    const [tools, setTools] = useState([]);

    useEffect(() => {
        fetch('https://agile-brook-59909.herokuapp.com/tools')
            .then(res => res.json())
            .then(data => setTools(data));
    }, []);
    return [tools, setTools]
}
export default useTool;